/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Search from './Search';
import { fetchSearch } from '../../actions/search'

async function action({ store, params }) {
  await store.dispatch(fetchSearch(params.wd));
  if (process.env.BROWSER && window.NProgress) {
    window.NProgress.done()
  }

  return {
    chunks: ['search'],
    title: '搜索结果-有道精品课-为你精选好课',
    component: <Search />,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/search/index.js